// extracted by mini-css-extract-plugin
export default {"button":"button__aZlfm","large":"large__lvjNs","hover":"hover__J0w05","disab":"disab__a5U0h"};